import groq from 'groq'

import { callToAction } from '../../callToAction'

export const header = groq`
 _type,
  title,
  descriptionLabel,
  description,
  bottomNote,
  cta {${callToAction()}}
`
